import { convertDraftToTiptap } from 'common/utils/convert-draft-to-tiptap'

const TAGGED_JSON_REGEX =
  /^<([a-z0-9]+)(\s[^>]*)?>\s*(?:"((?:\\.|[^"])*)"|&quot;([\s\S]*?)&quot;)\s*<\/\1>\s*$/is

export const isDraftLike = (value: string): boolean => {
  if (typeof value !== 'string') {
    return false
  }
  const trimmed = value.trim()
  if (trimmed.startsWith('{')) {
    return true
  }

  return TAGGED_JSON_REGEX.test(trimmed)
}

export const extractDraftJson = (value: string): string => {
  const trimmed = value.trim()
  if (trimmed.startsWith('{')) {
    return trimmed
  }

  const match = trimmed.match(TAGGED_JSON_REGEX)
  if (!match) {
    return value
  }

  const result = match[3] ?? match[4] ?? ''

  try {
    return JSON.parse(`"${result}"`)
  } catch {
    return value
  }
}

export const isDraftContent = (content: string) => {
  if (!isDraftLike(content)) {
    return content
  }
  const draft = extractDraftJson(content)
  return draft.startsWith('{') ? convertDraftToTiptap(draft) : content
}
